// jsTree - is jquery plugin, that provides interactive trees: https://www.jstree.com/
window.jstree = require('jstree/dist/jstree.js');

require('./jstree.scss');
